import { css } from '@/styled-system/css';

export const toggleButtonLoadingStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  inset: '0',
  zIndex: 2,
});
